import { clearTokens, cancelProactiveRefresh } from './authTokens';

export const performLogout = (navigate) => {
  localStorage.removeItem('userId');
  localStorage.removeItem('username');
  localStorage.removeItem('userRole');
  localStorage.removeItem('companyId');
  clearTokens();
  cancelProactiveRefresh();
  navigate('/login');
};
